<template>
  <div class="optionitem">
    <img :src="image" v-show="isSelectedOption"> 
    <img :src="inactive" v-show="!isSelectedOption"> 
    <p :class="{'active': isSelectedOption}">{{ text }}</p>
  </div>
</template>

<script>
export default {
  name:"FilterNavigationItem",
  props:["text","image","inactive","isSelectedOption"],

}
</script>

<style scoped>
.optionitem{
  display: inline-flex;
  justify-items: center;
  flex-direction: column;
  align-items: center;
  padding-top: 15px;
  padding-bottom: 15px;
}

img{
  width: 20px;
}

.optionitem:hover{
  cursor: pointer;
}

p{
  margin-bottom: 0;
  font-family: "Montserrat";
  font-size: 20px;
}

p.active{
  color: #2650e7;
}


@media only screen and (max-width: 767px) {
  .optionitem{
    color: rgb(58, 58, 58);
  }

  img{
    width: 25px;
  }
  
  p{
    font-size: 12px;
  }
}

</style>